export const colleaguesConstants = {
  UPDATE_COLLEAGUE: '[Colleagues] Update',
  REMOVE_COLLEAGUE: '[Colleagues] Remove',
  LOADING_COLLEAGUES: '[Colleagues] Loading',
  LOADING_COLLEAGUES_ERROR: '[Colleagues] Loading error'
}
